import { compose } from 'recompose'
import cx from 'classnames'

import './style.styl'

export default compose()(({
  onClose,
  title,
  children,
  className = '',
  long = false,
}) => (
  <div className={cx('tiny-editor-modal', { 'tiny-editor-modal-long': long })}>
    <div className={cx('tiny-editor-modal-overlay', { 'tiny-editor-modal-long': long })} onClick={onClose} />
    <div className={cx('tiny-editor-modal-content', { [className]: !!className, 'tiny-editor-modal-long': long })}>
      <header className={cx('tiny-editor-modal-header', { 'tiny-editor-modal-long': long })}>
        <span className="tiny-editor-modal-title">{title}</span>
        <span className="drift-button tiny-editor-modal-close-button" onClick={onClose}>
          &times;
        </span>
      </header>
      <div className="tiny-editor-modal-body">
        {children}
      </div>
    </div>
  </div>
))



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TinyEditorModal/index.js